<template>
  <div id="contrast" ref="contrast">
    <div class="contrast-content" v-for="(item, index) in list">
      <land-card-detail
        class="contrast-li"
        :key="index"
        :land-id="item.id"
      ></land-card-detail>
      <div
        v-if="index != list.length"
        class="parting-line"
        :style="{ height: `${boxHeight + 10}px` }"
      ></div>
    </div>
  </div>
</template>
<script>
import LandCardDetail from "./landCardDetail";
export default {
  name: "contrast",
  components: { LandCardDetail },
  data() {
    return {
      list: [],
      boxHeight: 400,
      definitionDom: {
        htmlDom: {},
        bodyDom: {},
        appDom: {},
      },
    };
  },
  mounted() {
    this.list = JSON.parse(sessionStorage.getItem("contrastList"));
    this.loadPartingLine();
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "100%";
  },
  methods: {
    loadPartingLine() {
      setTimeout(() => {
        this.boxHeight = this.$refs.contrast.scrollHeight;
        this.setAppHeight();
      }, 1000);
    },
    // 设置最外层 dom 的高度 为自动
    setAppHeight() {
      let ddom = this.definitionDom;
      let h = "auto";
      ddom.htmlDom = document.getElementsByTagName("html");
      ddom.bodyDom = document.getElementsByTagName("body")[0];
      ddom.appDom = document.getElementById("app");
      ddom.htmlDom.height = h;
      ddom.bodyDom.style.height = h;
      ddom.appDom.style.height = h;
    },
  },
  destroyed() {
    // 还原高度设置
    let h = "100%";
    let ddom = this.definitionDom;
    ddom.htmlDom.height = h;
    ddom.bodyDom.style.height = h;
    ddom.appDom.style.height = h;
  },
};
</script>
<style scoped>
#contrast {
  overflow: auto;
  display: flex;
  background: #fff;
}
.contrast-content {
  flex: 0 0 auto;
  width: 50%;
  padding: 10px 20px;
  position: relative;
}
.parting-line {
  width: 1px;
  margin-right: 5px;
  border-right: 1px solid #d9d9d9;
  position: absolute;
  top: 0px;
  right: -25px;
}
.contrast-li:last-child {
  border-right: none;
}
.contrast-colse {
  position: absolute;
  top: 0;
  width: 35px;
  height: 35px;
  background: #4f8de9;
  border-radius: 0 0 0 100px;
  color: #fff;
  right: 0;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}
</style>
